import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { categoryLabel } from '@/utils/creator-helpers';

const TYPE_LABEL = { persona: 'Persona', empresa: 'Empresa' } as const;

// Muestra el tipo + categoría que el collector asignó al creator (distinto
// del ai_category, que es la clasificación de la IA). Útil para que el
// admin sepa qué se está validando antes de aceptar la apelación.
export function CurrentCategoryLine({
  creator,
}: {
  creator: Creator;
}): ReactNode {
  const label = categoryLabel(creator.creator_type, creator.category);
  return (
    <p className="text-xs text-text-secondary">
      <span className="text-text-tertiary">Categoría actual: </span>
      {TYPE_LABEL[creator.creator_type]} · {label}
    </p>
  );
}
